<div class="group-settings-modal" *ngIf="definition">
  <p class="modal-intro">
    Configure the page and tab order for <strong>{{ modalConfig.data?.groupDisplay }}</strong>.
    Removing a tab does not delete its dashboard.
  </p>

  <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

  <p-tabView styleClass="dashboard-group-tabs">
    <p-tabPanel header="General Settings">
      <section class="group-properties">
        <label>
          <span>Group title</span>
          <input class="form-control" [(ngModel)]="definition.title" />
        </label>
        <label>
          <span>Icon class</span>
          <input class="form-control" [(ngModel)]="definition.iconClass" placeholder="fa fa-bar-chart" />
        </label>
        <label class="full-width">
          <span>Description</span>
          <textarea class="form-control" rows="2" [(ngModel)]="definition.description"></textarea>
        </label>
        <label>
          <span>Default dashboard</span>
          <select class="form-control" [(ngModel)]="definition.defaultDashboardKey">
            <option [ngValue]="undefined">First tab</option>
            <option *ngFor="let tab of definition.tabs" [ngValue]="tab.dashboardKey">{{ tab.display }}</option>
          </select>
        </label>
        <label class="single-tab-option">
          <input type="checkbox" [(ngModel)]="definition.hideTabsWhenSingleVisible" />
          <span>Hide tabs when the group has one dashboard</span>
        </label>
      </section>
    </p-tabPanel>

    <p-tabPanel header="Contexts">
      <section class="group-contexts">
        <div class="context-heading">
          <div>
            <strong>Global CAP contexts</strong>
            <small>Contexts are resolved once for the group and shared with tab visibility, dashboard filters, and widgets.</small>
          </div>
          <span>{{ definition.contextNames?.length || 0 }} selected</span>
        </div>
        <dw-context-def-multi-select [ngModel]="definition.contextNames"
          (ngModelChange)="onContextNamesChanged($event)">
        </dw-context-def-multi-select>
        <div class="required-contexts" *ngIf="requiredContextNames.length">
          <i class="fa fa-lock"></i>
          <span><strong>Required by dashboards:</strong> {{ requiredContextNames.join(', ') }}</span>
        </div>
        <div class="context-note">
          <i class="fa fa-sync-alt"></i>
          CAP context cache invalidation automatically causes the group and active dashboard to reload.
        </div>
      </section>
    </p-tabPanel>

    <p-tabPanel header="Dashboards">
      <div class="tabs-heading">
        <div><strong>Dashboard tabs</strong><small>Order is used by the reporting page.</small></div>
        <span>{{ definition.tabs.length }} tab{{ definition.tabs.length === 1 ? '' : 's' }}</span>
      </div>

      <section class="add-dashboard-row">
        <div>
          <strong>Add or clone a dashboard</strong>
          <small>Configured dashboards can be cloned as an independent starting point.</small>
        </div>
        <p-dropdown [options]="dashboardSelectionOptions" optionLabel="label" optionValue="value"
          [filter]="true" filterBy="label" [showClear]="true" appendTo="body"
          placeholder="Choose a dashboard" [(ngModel)]="selectedDashboardAction">
        </p-dropdown>
        <button type="button" class="btn btn-outline-primary" [disabled]="!selectedDashboardAction" (click)="addDashboard()">
          <i class="fa" [class.fa-copy]="selectedDashboardActionType === 'clone'"
            [class.fa-plus]="selectedDashboardActionType !== 'clone'"></i>
          {{ selectedDashboardActionType === 'clone' ? 'Clone' : 'Add' }}
        </button>
      </section>

      <div class="catalog-empty" *ngIf="!dashboardSelectionOptions.length">
        No active dashboards are available to add or clone.
      </div>

      <dw-ordered-list class="dashboard-tab-order" [class.single-dashboard]="definition.tabs.length === 1"
        [(items)]="definition.tabs"
        (itemsChange)="onTabsChanged()" (itemRemoved)="onTabRemoved($event)"
        *ngIf="definition.tabs.length">
        <ng-container *dwListItem="let tab">
          <div class="tab-order-content">
            <div class="tab-fields">
              <label>
                <span>Tab name</span>
                <input class="form-control" [(ngModel)]="tab.display" />
              </label>
              <label>
                <span>Icon class</span>
                <input class="form-control" [(ngModel)]="tab.iconClass" placeholder="Optional" />
              </label>
              <div class="dashboard-reference">
                <span>Dashboard</span>
                <strong>{{ dashboardDisplay(tab.dashboardKey) }}</strong>
                <small>{{ tab.dashboardKey }}</small>
                <em *ngIf="!dashboardIsActive(tab.dashboardKey)">Missing or inactive</em>
              </div>
              <label class="tab-visibility">
                <span>Visibility expression</span>
                <dw-expression-picker-control [(ngModel)]="tab.visibleExpression"
                  [contextNames]="definition.contextNames || []"
                  (ngModelChange)="onTabVisibilityChanged()">
                </dw-expression-picker-control>
              </label>
            </div>
            <div class="tab-row-actions">
              <button type="button" class="default-tab"
                [class.active]="definition.defaultDashboardKey === tab.dashboardKey"
                [title]="definition.defaultDashboardKey === tab.dashboardKey ? 'Default dashboard' : 'Make default'"
                (click)="setDefaultDashboard(tab.dashboardKey)">
                <i class="fa" [class.fa-star]="definition.defaultDashboardKey === tab.dashboardKey"
                  [class.fa-star-o]="definition.defaultDashboardKey !== tab.dashboardKey"></i>
              </button>
            </div>
          </div>
        </ng-container>
      </dw-ordered-list>
    </p-tabPanel>
  </p-tabView>
</div>
